// extracted by mini-css-extract-plugin
export default {"logoGrid":"LogoSection_logoGrid__YmTMU","logoItem":"LogoSection_logoItem__2zauj","logoImage":"LogoSection_logoImage__SdmfN"};